import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addShipment } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddShipment(orderId: string) {
  const queryClient = useQueryClient()
  const { accessToken } = useAuthStore()

  return useMutation({
    mutationFn: async (payload: { provider: string; trackingUrl: string; trackingId: string }) => {
      if (!accessToken) throw new Error("No token available")
      return addShipment(orderId, payload, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-orders"] })
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", orderId] })
    },
    onError: (error: any) => {
      console.error("Failed to add shipment details:", error)
    },
  })
}
